GP.vent.on('init_js:billing:add_credits', function(self) {
    $(function() {
        $("form button").on("click", function() {
            $("form button").attr('disabled', 'disabled');
            $(this).parent('form').submit();
        });
    }); 

});
